import config from "./config";
var axios = config();

export default {
  getSiteVisit(id) {
    return axios.get("/api/SiteVisit/Get", { params: { id: id } });
  },

  getSiteVisits() {
    return axios.get("/api/SiteVisits/Get", {});
  },

  getTypes() {
    return axios.get("/api/SiteVisits/Types", {});
  },

  getForSite(siteId) {
    return axios.get("/api/SiteVisits/GetForSite", {
      params: { siteId: siteId }
    });
  },

  postSiteVisit(siteVisit) {
    return axios.post("/api/SiteVisits/Create", siteVisit);
  }
};
